export const SLOT_ONLY_COLUMN = [
  'heikin_dankai_settei',
  'dedama_ritsu',
  'game_50mai',
  'saidai_dedamasu',
  'saidai_suikomisu'
];
export default SLOT_ONLY_COLUMN;
